module.exports = __webpack_public_path__ + "img/c2.f50396c5.jpg";